import { isRetailContext } from '@invivodf/common/src/application/composables/useContext'
import { startB2agApp } from '@/main/main-b2ag'
import { startRetailApp } from '@/main/main-retail'

if (isRetailContext()) {
  startRetailApp()
} else {
  startB2agApp()
}
